import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_41: FaireProductEntity = {
  token: "starter_collection_41",
  type: "product",
  name: "Niko Champagne Flute",
  brandName: "Be Home",
  imageUrl: "",
  priceDollars: 16,
  msrpDollars: 32,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
